export const DETECTOR_RESULTS = 'detector_results';
export const TRUST_SCORE = 'trust_score';
export const SENSITIVE_INFORMATION_EDITED = 'sensitive_information_edited';
export const DOCUMENT_SOFTWARE = 'document_software';

export const PRIVATE_INTERNAL_CHECKS = [
  DETECTOR_RESULTS,
  TRUST_SCORE,
  SENSITIVE_INFORMATION_EDITED,
  DOCUMENT_SOFTWARE,
];
